import { render } from "./AnswerLoop.vue?vue&type=template&id=5021ceb2&scoped=true"
import script from "./AnswerLoop.vue?vue&type=script&lang=js"
export * from "./AnswerLoop.vue?vue&type=script&lang=js"

import "./AnswerLoop.vue?vue&type=style&index=0&id=5021ceb2&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5021ceb2"]])

export default __exports__